import { TableColumn } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { ConfiguredColumnComponent } from '../components/configured-column.component';
import { ProvisioningStatusColumnComponent } from '../components/provisioning-status-column.component';
import { DeviceIdColumnComponent } from '../components/device-id-column.component';

export const createBaseStationColumns = (): TableColumn[] => [
  {
    field: 'deviceId',
    title: TranslateRegistry.get.BASE_STATION_PROVISIONING.VIEW_TABLE.DEVICE_ID,
    width: 140,
    sortable: true,
    cmp: DeviceIdColumnComponent
  },
  {
    field: 'model',
    title: TranslateRegistry.get.BASE_STATION_PROVISIONING.VIEW_TABLE.MODEL,
    width: 150,
    sortable: true
  },
  {
    field: 'provisioningStatus',
    title: TranslateRegistry.get.BASE_STATION_PROVISIONING.VIEW_TABLE.PROVISIONING_STATUS,
    width: 200,
    sortable: true,
    cmp: ProvisioningStatusColumnComponent
  },
  {
    field: 'macId',
    title: TranslateRegistry.get.BASE_STATION_PROVISIONING.VIEW_TABLE.MAC_ID,
    width: 280,
    sortable: true
  },
  {
    field: 'backhaulConnectionConfigured',
    title: TranslateRegistry.get.BASE_STATION_PROVISIONING.VIEW_TABLE.BACKHAUL_CONFIGURATION,
    width: 200,
    sortable: true,
    cmp: ConfiguredColumnComponent
  },
  {
    field: 'ranConfigured',
    title: TranslateRegistry.get.BASE_STATION_PROVISIONING.VIEW_TABLE.RAN_CONFIGURATION,
    width: 200,
    sortable: true,
    cmp: ConfiguredColumnComponent
  },
  {
    field: 'provisioningDateTime',
    title: TranslateRegistry.get.BASE_STATION_PROVISIONING.VIEW_TABLE.PROVISIONING_DATE_TIME,
    width: 220,
    sortable: true
  }
];
